<template>
  <md-card class="m-0">
    <md-card-header>Source &amp; Uses of Funds</md-card-header>
    <md-card-content>
      <div class="md-layout sources-users-content">
        <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
          <md-table v-model="changein" table-header-color="blue" class="sources-users-table">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Change In:">
                {{
                  item.title
                }}
              </md-table-cell>

              <md-table-cell md-label="Trend" class="table_chart">
                <chart-card
                  header-animation="false"
                  :chart-data="newChartChangeinOptions[item.name].data"
                  :chart-options="chartOptions"
                  chart-type="Line"
                  header-icon
                  chart-inside-content
                  no-footer
                  background-color="blue"
                ></chart-card>
              </md-table-cell>

              <md-table-cell
                v-for="key in Object.keys(item.dates)"
                :key="key + 'change'"
                :md-label="key"
              >{{ numberWithCommas(item.dates[key]) }}</md-table-cell>
            </md-table-row>
          </md-table>
          <div class="md-layout px-4">
            <p><b>Sources and Uses:</b> The Sources and Uses of Funds table tests the accuracy of the balance sheet and distinguishes the sources of funds from their use. It is the basic worksheet preliminary to a formal cash flow statement examining the liquidity of a business. A multi-year industry benchmark common size balance sheet, which includes overlapped but not identical sets of firms in each year, is not well-suited for the presentation of a formal cash flow analysis.</p>
          </div>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
// import { Collapse } from "@/components";
import { ChartCard } from "@/components";
import { mapState } from "vuex";
import formatData from "@/mixins/format-data";

export default {
  components: {
    ChartCard
    // Collapse,
  },
  mixins: [formatData],
  data() {
    return {
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollar: [],
      filtered_PLPercent: [],
      filtered_BSDollar: [],
      filtered_BSPercent: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      sales_class_csv: "",
      newChartChangeinOptions: [],
      newChartWorksheetOptions: [],
      chartOptions: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 1,
        }),
        chartPadding: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0,
        },
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          scaleMinSpace: 6
        },
        showPoint: true,
        showLabel: false,
        width: "100px",
        height: "25px",
        seriesBarDistance: 10,
        fullWidth: true,
      },
    };
  },
  computed: {
    ...mapState({
      data: (state) => state.user.profile.data,
      sourcesUses: (state) => state.user.profile["sourcesUses"],
      profile: (state) => state.user.profile,
      PLtable: (state) => state.user.profile.tables["PL"],
      BStable: (state) => state.user.profile.tables["BS"],
      tables: (state) => state.user.profile.tables["ratios"],
      ratioTablesInfo: (state) => state.user.profile.tables["ratioInfo"],
      sourceYears: (state) => state.user.profile["sourcesUses"]["years"],
      release_display: (state) => state.user.profile.release_display,
      bznaics_code: (state) => state.user.profile.bznaics,
      sector_name: (state) => state.user.profile.data[0].sector,
      industry_title: (state) => state.user.profile.data[0].industry,
      sales_class: (state) => state.user.profile.data[0].sales_class,
      display_area: (state) => state.user.profile.data[0].display_area,
    }),
    tablesInfo() {
      return _.omit(this.sourcesUses, "years");
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]["cashflow"];
    },
    getCsvData() {
      let csvData = [
        ["Industry Financial Report"],
        ['"Release Date"', this.release_display],
        [""],
        ["Segment", "Industry"],
        [this.industry_title],
        ["[" + parseInt(this.bznaics_code) + "]" + " Sector", this.sector_name],
        ["Market", this.display_area],
        ["Sales Class", this.sales_class_csv],
        [""],
      ];
      csvData.push(["Firms Analyzed", this.filtered_years]);
      csvData.push(["", this.filtered_firms]);
      csvData.push([""]);
      csvData.push(["Income and Expense - Profit and Loss($)"]);
      csvData.push(["", this.filtered_years]);
      this.filtered_PLDollar.forEach((e, i) => {
        if (e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push(["Income and Expense - Profit and Loss(%)"]);
      csvData.push(["", this.filtered_years]);
      this.filtered_PLPercent.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push(["Balance Sheet($)"]);
      csvData.push(["Assets", this.filtered_years]);
      this.filtered_BSDollar.forEach((e, i) => {
        if (e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push(["Balance Sheet(%)"]);
      csvData.push(["Assets", this.filtered_years]);
      this.filtered_BSPercent.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push(["Financial Ratios: Cash Flow-Solvency"]);
      csvData.push(["", this.filtered_years]);
      this.cashFlowFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Financial Ratios: Profitability"]);
      csvData.push(["", this.filtered_years]);
      this.profitabilityFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Financial Ratios: Efficiency"]);
      csvData.push(["", this.filtered_years]);
      this.efficiencyFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Financial Ratios: Debt-Risk"]);
      csvData.push(["", this.filtered_years]);
      this.debtRiskFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""]);
      csvData.push([""]);
      csvData.push([""]);
      csvData.push(["Sources & Uses of Funds"]);
      csvData.push(["", this.sourceYears]);
      this.changeinFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push(["Worksheet:"]);
      this.worksheetFilteredData.forEach((e, i) => {
        if (typeof e == "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      return csvData;
    },
  },
  mounted() {
    this.profile.years.forEach((e, i) => {
      this.filtered_years.push(e);
    });
    let firmData = Object.values(this.profile.data)
      .filter((item) => item)
      .map((item) => ({ ...item, firms: item.firms }));

    firmData.forEach((element) => {
      this.filtered_firms.push(parseFloat(element.firms));
    });
    if (this.sales_class.includes(",")) {
      this.sales_class_csv = this.sales_class.replace(/,/g, "");
    }
    let PLdollar = this.formatTable(this.PLtable, "industry", "dollar");
    let PLpercent = this.formatTable(this.PLtable, "industry", "percent");

    PLdollar.forEach((element) => {
      if (element.name.includes(",")) {
        element.name = element.name.replace(/,/g, "");
      }
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (e.includes(",")) {
          e = parseFloat(e.replace(/,/g, ""));
        }
        v.push(e);
      });
      v.unshift(element.name);
      this.filtered_PLDollar.push(v);
    });
    PLpercent.forEach((element) => {
      if (element.name.includes(",")) {
        element.name = element.name.replace(/,/g, "");
      }
      let z = Object.values(element.dates);
      let v = [];
      z.forEach((item, i) => {
        if (typeof item === "string" && item.includes(",")) {
          item = parseFloat(item.replace(/,/g, ""));
        }
        v.push(item);
      });
      v.unshift(element.name);
      this.filtered_PLPercent.push(v);
    });

    let BSdollar = this.formatTable(this.BStable, "industry", "dollar");
    let BSpercent = this.formatTable(this.BStable, "industry", "percent");

    BSdollar.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (e.includes(",")) {
          e = parseFloat(e.replace(/,/g, ""));
        }
        v.push(e);
      });

      v.unshift(element.name);
      this.filtered_BSDollar.push(v);
    });
    BSpercent.forEach((element) => {
      let z = Object.values(element.dates);
      let v = [];
      z.forEach((item, i) => {
        if (typeof item === "string" && item.includes(",")) {
          item = parseFloat(item.replace(/,/g, ""));
        }
        v.push(item);
      });
      v.unshift(element.name);
      this.filtered_BSPercent.push(v);
    });

    if (!_.isEmpty(this.tables)) {
      Object.entries(this.tables).forEach(
        ([table, data]) => (this[table] = this.formatTable(data, "industry"))
      );
    }
    let cashFlowData = [];
    this.cashflow.forEach((element, index) => {
      if (element.name in this.tables["cashflow"]) {
        cashFlowData.push({
          dates: element.dates,
          title: this.ratioTablesInfo[element.name]["title"],
        });
      }
    });
    cashFlowData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (e.includes(",")) {
          e = parseFloat(e.replace(/,/g, ""));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.cashFlowFilteredData.push(v);
    });

    let efficiencyData = [];
    this.efficiency.forEach((element, index) => {
      if (element.name in this.tables["efficiency"]) {
        efficiencyData.push({
          dates: element.dates,
          title: this.ratioTablesInfo[element.name]["title"],
        });
      }
    });
    efficiencyData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (e.includes(",")) {
          e = parseFloat(e.replace(/,/g, ""));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.efficiencyFilteredData.push(v);
    });

    let profitabilityData = [];
    this.profitability.forEach((element, index) => {
      if (element.name in this.tables["profitability"]) {
        profitabilityData.push({
          dates: element.dates,
          title: this.ratioTablesInfo[element.name]["title"],
        });
      }
    });
    profitabilityData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (e.includes(",")) {
          e = parseFloat(e.replace(/,/g, ""));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.profitabilityFilteredData.push(v);
    });

    let debtRiskData = [];
    this.turnover.forEach((element, index) => {
      if (element.name in this.tables["turnover"]) {
        debtRiskData.push({
          dates: element.dates,
          title: this.ratioTablesInfo[element.name]["title"],
        });
      }
    });
    debtRiskData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (e.includes(",")) {
          e = parseFloat(e.replace(/,/g, ""));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.debtRiskFilteredData.push(v);
    });

    Object.entries(this.tablesInfo).forEach(([table, data]) =>
      this.$set(this, table, this.formatData(table, data))
    );

    this.changein = this.changein.concat(this.worksheet);

    this.changein.forEach((element, index) => {
      let k = [];
      Object.values(element.dates).forEach((e, index) => {
        k.push(e);
      });
      k.unshift(element.title);
      this.changeinFilteredData.push(k);
    });
    this.changein.forEach(element => {
      this.newChartChangeinOptions[element.name] = {
        data: {
          labels: [[...Object.keys(element.dates).map(i => parseFloat(element.dates[i]))]],
          series: [[...Object.keys(element.dates).map(i => parseFloat(element.dates[i]))]]
        },
      }
    });
    this.worksheet.forEach((element, index) => {
      let k = [];
      Object.values(element.dates).forEach((e, index) => {
        k.push(e);
      });
      k.unshift(element.title);
      this.worksheetFilteredData.push(k);
    });
    this.worksheet.forEach(element => {
      this.newChartWorksheetOptions[element.name] = {
        data: {
          labels: [[...Object.keys(element.dates).map(i => parseFloat(element.dates[i]))]],
          series: [[...Object.keys(element.dates).map(i => parseFloat(element.dates[i]))]]
        },
      }
    });
  },
  methods: {
    downloadCSVData() {
      let csv = "";
      this.getCsvData.forEach((row) => {
        csv += row.join(",");
        csv += "\n";
      });
      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "Industry Financial Profile.csv";
      anchor.click();
    },
    formatData(table, data) {
      let getDates = (id) =>
        this.sourceYears.reduce((acc, cur, index) => {
          let value = this.actualData[this.sourceYears.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
  },
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}
.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}
.md-card-content .sources-users-content {
    background-color: #ffffff;
}
</style>
